import { func, object, shape, string, number, bool } from 'prop-types';

export const intlShape = shape({
  locale: string,
  formatMessage: func,
  formatTime: func,
});

export const locationShape = shape({
  pathname: string.isRequired,
  search: string.isRequired,
  hash: string,
  state: object,
});

export const historyShape = shape({
  action: string.isRequired,
  block: func.isRequired,
  createHref: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired,
  listen: func.isRequired,
  length: number.isRequired,
  push: func.isRequired,
  replace: func.isRequired,
  location: locationShape.isRequired,
});

export const matchShape = shape({
  isExact: bool.isRequired,
  path: string.isRequired,
  url: string.isRequired,
  params: object,
});

export const staticContextShape = object;

export const withRouterPropTypes = {
  match: matchShape.isRequired,
  location: locationShape.isRequired,
  history: historyShape.isRequired,
  staticContext: staticContextShape,
};

export default {
  locationShape,
  matchShape,
  historyShape,
  staticContextShape,
};
